module.exports = __webpack_public_path__ + "static/media/ann_makosinski.cabe18d8.png";